import styles from "./headerScoresBreakdown.module.css";
import { THeaderScore } from "../../services/types/user.types";
import { tWithKeyAttr as t } from "../../i18nHelper";
import RrmLink from "../rrmLink/rrmLink";
import {
  findBandForScore,
  mapCompanyGroupsRRMToDisplay,
} from "../../utils/rrmDisplay";

function HeaderScoresBreakdown({
  scores,
  layout = "grid",
}: {
  scores?: THeaderScore[] | null;
  layout?: "grid" | "split";
}) {
  if (!scores?.length) {
    return null;
  }

  const count = scores.length;
  const listClassName = [
    styles.list,
    layout === "split" && styles.list_split,
    count === 2 && styles.list_pair,
    count >= 3 && styles.list_many,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={`${styles.breakdown} ${
        layout === "split" ? styles.breakdown_split : ""
      }`}
      data-testid="header-scores-breakdown"
    >
      {layout !== "split" && (
        <p className={styles.title}>{t("HEADER_SCORES_TITLE")}</p>
      )}
      <ul className={listClassName}>
        {scores.map((item) => {
          const scoreList = mapCompanyGroupsRRMToDisplay(item.CompanyGroupsRRM);

          if (scoreList.length > 0) {
            const matched = findBandForScore(item.Score, scoreList);
            return (
              <li
                key={item.CompanyGroupsRRMHeadersId}
                className={`${styles.card} ${
                  layout === "split" ? styles.card_split : ""
                }`}
                data-testid="header-score-item"
              >
                <RrmLink
                  score={item.Score}
                  RRMScore={matched?.rrmseq ?? 0}
                  scoreList={scoreList}
                  showScoreInButton
                  label={item.Desc}
                  popupTitle={item.Desc}
                  embedded
                  additionalStyles={{}}
                />
              </li>
            );
          }

          return (
            <li
              key={item.CompanyGroupsRRMHeadersId}
              className={styles.item}
              data-testid="header-score-item"
            >
              <span className={styles.desc}>{item.Desc}</span>
              <span className={styles.score}>
                {t("SCORE")}: {item.Score}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default HeaderScoresBreakdown;
